import { Injectable } from '@angular/core';

const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'wheel',
  'click',
  'visibilitychange',
] as const;

const CHECK_INTERVAL_MS = 15_000;

@Injectable({ providedIn: 'root' })
export class InactivityService {
  private timeoutMs = 0;
  private lastActivityAt = 0;
  private onTimeout: (() => void) | null = null;
  private intervalId: ReturnType<typeof setInterval> | null = null;

  private readonly onActivity = (): void => {
    this.lastActivityAt = Date.now();
  };
  start(timeoutMs: number, onTimeout: () => void): void {
    this.stop();
    if (timeoutMs <= 0) return;

    this.timeoutMs = timeoutMs;
    this.onTimeout = onTimeout;
    this.lastActivityAt = Date.now();

    ACTIVITY_EVENTS.forEach((event) =>
      globalThis.document.addEventListener(event, this.onActivity, { passive: true }),
    );

    const checkInterval = Math.max(1000, Math.min(CHECK_INTERVAL_MS, timeoutMs / 4));
    this.intervalId = setInterval(() => this.check(), checkInterval);
  }

  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    ACTIVITY_EVENTS.forEach((event) =>
      globalThis.document.removeEventListener(event, this.onActivity),
    );
    this.onTimeout = null;
  }

  reset(): void {
    this.lastActivityAt = Date.now();
  }

  private check(): void {
    if (Date.now() - this.lastActivityAt < this.timeoutMs) return;

    const callback = this.onTimeout;
    this.stop();
    callback?.();
  }
}
